/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const DropdownCaretIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="-1 -1 12 10"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-280.000000, -18.000000)" fill="#6F6F6F">
        <g transform="translate(0.000000, 2.000000)">
          <polygon points="290 16 285 24 280 16" />
        </g>
      </g>
    </g>
  </svg>
);

export default DropdownCaretIcon;
